// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.license-picker-wrapper {
   display: flex;
   flex-direction: column;
   justify-content: center;
   align-items: center;
   margin: 30px;
   border: var(--border)
}

.license-picker-container {
   display: flex;
   padding: var(--padding);
   padding-top: 0;
   flex-wrap: wrap;
   align-items: center;
   justify-content: center;
}

.license-picker-container .license-picker-info {
   display: flex;
   flex-direction: column;
   width: 35%;
   min-width: 350px
}

.license-picker-container .license-picker-form {
   display: flex;
   padding: var(--padding);
   width: 65%;
   flex-direction: column;
   min-width: 350px
}

.license-picker-form legend {
   display: none;
}

.license-picker-form fieldset {
   border: none;
   width: 100%;
   margin: 0;
   padding: 0;
}

.license-picker-form .license-picker-form-field {
   display: flex;
   flex-direction: row;
   justify-content: space-between;
   align-items: center;
}

.license-picker-form img {
   width: 20px;
}

.license-picker-form p {
   text-align: left;
   font-style: italic;
   font-size: .7rem;
}

.license-picker-form label {
   cursor: pointer;
   width: 100%;
}

.license-picker-button-bar {
   display: flex;
   flex-direction: row;
   justify-content: flex-end;
}

/* Radio styling, look to standardize this since no one should have to do this regularly */
.license-picker-form input[type=radio] {
   min-height: 1.5em;
   min-width: 1.5em;
   cursor: pointer;
}

.license-picker-form input[type=radio]::before {
   visibility: hidden;
   display: block;
   font-size: 1.2rem;
}

/* I wanna do more here, but I think radios should be standard across all forms (Thus em sizing) */
html body nav input[type=radio]:checked::before {
   visibility: visible;
   font-size: 1.2rem;
}`, "",{"version":3,"sources":["webpack://./src/pages/components/LicensePicker/LicensePicker.css"],"names":[],"mappings":"AAAA;GACG,aAAa;GACb,sBAAsB;GACtB,uBAAuB;GACvB,mBAAmB;GACnB,YAAY;GACZ;AACH;;AAEA;GACG,aAAa;GACb,uBAAuB;GACvB,cAAc;GACd,eAAe;GACf,mBAAmB;GACnB,uBAAuB;AAC1B;;AAEA;GACG,aAAa;GACb,sBAAsB;GACtB,UAAU;GACV;AACH;;AAEA;GACG,aAAa;GACb,uBAAuB;GACvB,UAAU;GACV,sBAAsB;GACtB;AACH;;AAEA;GACG,aAAa;AAChB;;AAEA;GACG,YAAY;GACZ,WAAW;GACX,SAAS;GACT,UAAU;AACb;;AAEA;GACG,aAAa;GACb,mBAAmB;GACnB,8BAA8B;GAC9B,mBAAmB;AACtB;;AAEA;GACG,WAAW;AACd;;AAEA;GACG,gBAAgB;GAChB,kBAAkB;GAClB,gBAAgB;AACnB;;AAEA;GACG,eAAe;GACf,WAAW;AACd;;AAEA;GACG,aAAa;GACb,mBAAmB;GACnB,yBAAyB;AAC5B;;AAEA,0FAA0F;AAC1F;GACG,iBAAiB;GACjB,gBAAgB;GAChB,eAAe;AAClB;;AAEA;GACG,kBAAkB;GAClB,cAAc;GACd,iBAAiB;AACpB;;AAEA,kGAAkG;AAClG;GACG,mBAAmB;GACnB,iBAAiB;AACpB","sourcesContent":[".license-picker-wrapper {\r\n   display: flex;\r\n   flex-direction: column;\r\n   justify-content: center;\r\n   align-items: center;\r\n   margin: 30px;\r\n   border: var(--border)\r\n}\r\n\r\n.license-picker-container {\r\n   display: flex;\r\n   padding: var(--padding);\r\n   padding-top: 0;\r\n   flex-wrap: wrap;\r\n   align-items: center;\r\n   justify-content: center;\r\n}\r\n\r\n.license-picker-container .license-picker-info {\r\n   display: flex;\r\n   flex-direction: column;\r\n   width: 35%;\r\n   min-width: 350px\r\n}\r\n\r\n.license-picker-container .license-picker-form {\r\n   display: flex;\r\n   padding: var(--padding);\r\n   width: 65%;\r\n   flex-direction: column;\r\n   min-width: 350px\r\n}\r\n\r\n.license-picker-form legend {\r\n   display: none;\r\n}\r\n\r\n.license-picker-form fieldset {\r\n   border: none;\r\n   width: 100%;\r\n   margin: 0;\r\n   padding: 0;\r\n}\r\n\r\n.license-picker-form .license-picker-form-field {\r\n   display: flex;\r\n   flex-direction: row;\r\n   justify-content: space-between;\r\n   align-items: center;\r\n}\r\n\r\n.license-picker-form img {\r\n   width: 20px;\r\n}\r\n\r\n.license-picker-form p {\r\n   text-align: left;\r\n   font-style: italic;\r\n   font-size: .7rem;\r\n}\r\n\r\n.license-picker-form label {\r\n   cursor: pointer;\r\n   width: 100%;\r\n}\r\n\r\n.license-picker-button-bar {\r\n   display: flex;\r\n   flex-direction: row;\r\n   justify-content: flex-end;\r\n}\r\n\r\n/* Radio styling, look to standardize this since no one should have to do this regularly */\r\n.license-picker-form input[type=radio] {\r\n   min-height: 1.5em;\r\n   min-width: 1.5em;\r\n   cursor: pointer;\r\n}\r\n\r\n.license-picker-form input[type=radio]::before {\r\n   visibility: hidden;\r\n   display: block;\r\n   font-size: 1.2rem;\r\n}\r\n\r\n/* I wanna do more here, but I think radios should be standard across all forms (Thus em sizing) */\r\nhtml body nav input[type=radio]:checked::before {\r\n   visibility: visible;\r\n   font-size: 1.2rem;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
